import { render } from "./bloodGroupSearch.vue?vue&type=template&id=76b27085&scoped=true"
import script from "./bloodGroupSearch.vue?vue&type=script&lang=js"
export * from "./bloodGroupSearch.vue?vue&type=script&lang=js"

import "./bloodGroupSearch.vue?vue&type=style&index=0&id=76b27085&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b27085"]])

export default __exports__